import React, { memo, useMemo, lazy, Suspense } from 'react'
import { Loading } from 'components/shared'
import { useSelector } from 'react-redux'
import useAuth from 'utils/hooks/useAuth'
import useDirection from 'utils/hooks/useDirection'
import useLocale from 'utils/hooks/useLocale'
import { useLocation } from 'react-router-dom'

const Layout = () => {
    const layoutType = useSelector((state) => state.theme.layout.type)

    const location = useLocation()

    const { authenticated } = useAuth()

    useDirection()
    
    useLocale()

    const SiteLayout = useMemo(() => {
        const id = location.pathname.substring(
            location.pathname.lastIndexOf('/') + 1
        )
        if(id === "sign-out") {
            return lazy(() => import('../../views/auth/SignOut'))
        } else {
            if (authenticated) {
                return lazy(() => import('./AppLayout'))
            }
            return lazy(() => import('../../views'))
        }

    }, [authenticated])

    return (
        <Suspense
            fallback={
                <div className="flex flex-auto flex-col h-[100vh]">
                    {/* <Loading loading={true} /> */}
                </div>
            }
        >
            <SiteLayout />
        </Suspense>
    )
}

export default memo(Layout)
